"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_removable-value.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function RemovableBrandValue(_ref) {
  var handleRemoveClick = _ref.handleRemoveClick,
      handleInputChange = _ref.handleInputChange,
      index = _ref.index,
      value = _ref.value,
      description = _ref.description;
  var isFirstValue = index === 0;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "removable-value"
  }, isFirstValue ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "removable-value__line"
  }, /*#__PURE__*/_react.default.createElement("hr", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('removable-value__input', {
      'removable-value__input--first': isFirstValue
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "removable-value__input__value"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
    className: "brand-value",
    multiline: true,
    label: "Value ".concat(index + 1),
    placeholder: "Enter a value",
    defaultValue: value || '',
    onChange: handleInputChange(index, 'value')
  }), !isFirstValue && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    type: "TERTIARY",
    onClick: handleRemoveClick(index),
    prefix: "trash"
  })), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
    className: "removable-value__input__description",
    multiline: true,
    label: "Description",
    placeholder: "Enter description",
    defaultValue: description || '',
    onChange: handleInputChange(index, 'description')
  })));
}

var _default = (0, _react.memo)(RemovableBrandValue);

exports.default = _default;